/**
 * XUniqueSorted.
 * @param array - array of numbers
 * @returns - sorted array
 */
export function xUniqueSorted(array) {
    const unique = Float64Array.from(new Set(array));
    unique.sort();
    return unique;
}
//# sourceMappingURL=xUniqueSorted.js.map